import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const keysToMigrate = ['signatory1', 'signatory2', 'signatory3', 'signatory4'];

const migratePrivateDocument = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data } as Record<string, unknown>;
  const signatories = [];

  for (const key of keysToMigrate) {
    const value = data[key] as string;
    if (!value) continue;
    signatories.push(value);
    delete newData[key];
  }

  if (signatories.length) {
    newData.signatories = signatories;
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.PRIVATE_DOCUMENTS, migrateItemFunction: migratePrivateDocument },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration3: MigrationType = {
  migrate,
  version: 4,
};
